export default "__VITE_ASSET__38b58ef8__"